<div class="pos-diagnostics">
  <div class="row mb-4 align-items-center">
    <div class="col-md-8">
      <h4>POS Diagnostics</h4>
      <p class="text-muted mb-0">
        Kiosk errors, session journeys, build versions, and terminal comms health — readable during an outage without database access.
      </p>
    </div>
  </div>

  <nb-card class="mb-4">
    <nb-card-body class="p-0">
      <nav class="nav nav-tabs custom-tabs section-tabs">
        <a class="nav-link" [class.active]="activeSection === 'events'" (click)="setSection('events')" href="javascript:void(0)">
          <nb-icon icon="alert-triangle-outline" class="me-2"></nb-icon>
          Events
        </a>
        <a class="nav-link" [class.active]="activeSection === 'session'" (click)="setSection('session')" href="javascript:void(0)">
          <nb-icon icon="list-outline" class="me-2"></nb-icon>
          Session Timeline
        </a>
        <a class="nav-link" [class.active]="activeSection === 'kiosk-builds'" (click)="setSection('kiosk-builds')" href="javascript:void(0)">
          <nb-icon icon="monitor-outline" class="me-2"></nb-icon>
          Kiosk Builds
        </a>
        <a class="nav-link" [class.active]="activeSection === 'webapp-updates'" (click)="setSection('webapp-updates')" href="javascript:void(0)">
          <nb-icon icon="cloud-upload-outline" class="me-2"></nb-icon>
          Webapp Updates
        </a>
        <a class="nav-link" [class.active]="activeSection === 'terminal-health'" (click)="setSection('terminal-health')" href="javascript:void(0)">
          <nb-icon icon="activity-outline" class="me-2"></nb-icon>
          Terminal Health
        </a>
      </nav>
    </nb-card-body>
  </nb-card>

  <app-pos-diagnostics-list
    *ngIf="activeSection === 'events'"
    [storeId]="storeId"
    (viewSession)="openSessionTimeline($event)">
  </app-pos-diagnostics-list>

  <app-pos-diagnostics-session
    *ngIf="activeSection === 'session'"
    [storeId]="storeId"
    [initialSessionId]="sessionIdFromList">
  </app-pos-diagnostics-session>

  <app-kiosk-build-versions
    *ngIf="activeSection === 'kiosk-builds'"
    [storeId]="storeId">
  </app-kiosk-build-versions>

  <app-webapp-update-control
    *ngIf="activeSection === 'webapp-updates'"
    [storeId]="storeId">
  </app-webapp-update-control>

  <app-terminal-health
    *ngIf="activeSection === 'terminal-health'"
    [storeId]="storeId">
  </app-terminal-health>
</div>
